import React from 'react'
import PropTypes from 'prop-types'
import Spinner from '../common/Spinner';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Report4nested = ({ tableData, refresh, dividerForNested }) => {
  const valueConvert = (val, prec=2) => {
    if(typeof val === typeof 1) return Number(val).toFixed(prec).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".",",")
    return val
  }
 
  const getMeanValue = (cost) => {
    if(dividerForNested==0) return 'X'
    else{
      return valueConvert(cost/dividerForNested)//=='0,00'?'X':valueConvert(cost/dividerForNested)
    }
  }

  if(tableData){
    return (
      < >
            {/* <tr style={{fontWeight:'bold', textAlign: 'center'}}>
              <td>Konto zespołu 5 - Ośrodki zlecające numer konta</td>
              {Object.keys(tableData[0]).length==5 ?<>
                <td>Nazwa OPK</td>
                <td>Liczba wykonanych procedur/usług</td>
                <td>Koszt wykonanych procedur/usług [zł]</td>
              </>:<>
                <td colSpan='2'>Nazwa OPK</td>
                <td>Koszt [zł]</td>
              </>}
              <td>Udział w koszcie całkowitym OPK</td>
            </tr> */}
            {tableData.map((item, i) => {
              return (<tr key={`rep2-${i}`} className={item.code=="Wartość ogółem"?'tdTitles':''}>
                <td className=''>{item.code}</td>
                <td className=''>{item.name}</td>
                <td className='rightAlignCell' >{valueConvert(item.koszt)}</td>
                <td className='rightAlignCell' >{valueConvert(item.sredniomiesiecznie)}</td>
                <td className='rightAlignCell' >{valueConvert(item.koszt_proc)}%</td>
                {dividerForNested!==null&&
                  <td className='rightAlignCell'>{getMeanValue(item.koszt)}</td>
                }
              </tr>)
            })}
      </>
    )
  }else{
    return <tr><td colSpan='5'><Spinner /></td></tr>
  }
}
Report4nested.propTypes = {
  tableData: PropTypes.array,
  refresh: PropTypes.bool.isRequired,
}
export default Report4nested
